package com.eladfinish.bible.contest.features.review

import com.eladfinish.bible.contest.constants.SharedPrefsConstants
import com.eladfinish.bible.contest.currentMilliseconds
import com.eladfinish.bible.contest.di.config.DebugInfo
import com.eladfinish.bible.contest.features.verseWidget.VerseWidgetPromptSession
import com.eladfinish.bible.contest.repository.remoteConfig.RemoteConfig
import com.eladfinish.bible.contest.usecase.GetRemoteConfigObjectUseCase
import com.russhwolf.settings.Settings
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import org.koin.core.module.Module
import org.koin.dsl.module

val reviewModule = module {
    single { ReviewProgress(settings = get()) }

    single {
        ShouldRequestReviewUseCase(
            progress = get(),
            installInfoRepository = get(),
            nowMillis = { currentMilliseconds },
        )
    }

    single<ReviewPrompter> {
        val getRemoteConfigObjectUseCase = get<GetRemoteConfigObjectUseCase>()
        val settings = get<Settings>()
        val isDebugMode = get<DebugInfo>().isDebugMode
        DefaultReviewPrompter(
            launcher = get(),
            progress = get(),
            shouldRequestReview = get(),
            configProvider = {
                getRemoteConfigObjectUseCase<InAppReviewConfig>(remoteConfig = RemoteConfig.IN_APP_REVIEW)
                    ?: InAppReviewConfig()
            },
            analyticsProvider = get(),
            exceptionReporter = get(),
            isForced = { isDebugMode && settings.getBoolean(SharedPrefsConstants.REVIEW_DEBUG_FORCE, false) },
            nowMillis = { currentMilliseconds },
            requestScope = CoroutineScope(SupervisorJob() + Dispatchers.Default),
            onRequested = { get<VerseWidgetPromptSession>().onOtherPromptShown() },
        )
    }
}

/** Binds the platform's [InAppReviewLauncher]. */
expect val reviewPlatformModule: Module
